/* src/components/admin/announcements/dashboard/CategoryManagerModal.js */
import React, { useEffect, useState } from "react";
import { FiX, FiTrash2, FiEdit2, FiPlus } from "react-icons/fi";
import { FaCheck } from "react-icons/fa6";
import { addCategory, deleteCategory, renameCategory, subscribeCategories } from "../AdminAnnouncementsLogic";
import "./CategoryManagerModal.css";

export default function CategoryManagerModal({ onClose }) {
  const [categories, setCategories] = useState([]);
  const [newCat, setNewCat] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");

  useEffect(() => {
    const unsub = subscribeCategories(setCategories);
    return () => unsub();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newCat.trim()) return;
    try {
      await addCategory(newCat);
      setNewCat("");
    } catch (err) {
      alert(err.message);
    }
  };

  const handleDelete = async (id, name) => {
    if (!window.confirm(`Delete category "${name}"? Existing posts will keep this category text but it will be removed from the list.`)) return;
    await deleteCategory(id);
  };

  const startEdit = (c) => {
    setEditingId(c.id);
    setEditName(c.name);
  };

  const saveEdit = async (c) => {
    if (!editName.trim()) return;
    try {
      await renameCategory(c.id, c.name, editName);
      setEditingId(null);
    } catch (err) {
      alert("Failed to rename: " + err.message);
    }
  };

  return (
    <div className="aaModalBackdrop" onMouseDown={onClose}>
      <div className="aaModal aaCatModal" onMouseDown={e => e.stopPropagation()}>
        <div className="aaModalHead">
          <div className="aaModalTitle">Manage Categories</div>
          <button className="aaModalClose" onClick={onClose}><FiX size={20}/></button>
        </div>
        
        <div className="aaModalBody">
          <form className="aaCatAddRow" onSubmit={handleAdd}>
            <input 
              placeholder="New Category Name..." 
              value={newCat}
              onChange={e => setNewCat(e.target.value)}
            />
            <button type="submit" className="aaIconBtn primary"><FiPlus size={18}/></button>
          </form>

          <div className="aaCatManageList">
            {categories.length === 0 && <div className="aaCatEmpty">No saved categories.</div>}
            {categories.map(c => (
              <div key={c.id} className="aaCatManageItem">
                {editingId === c.id ? (
                  <>
                    <input 
                      className="aaCatEditInput"
                      value={editName}
                      onChange={e => setEditName(e.target.value)}
                      autoFocus
                    />
                    <button className="aaCatAction save" onClick={() => saveEdit(c)}><FaCheck size={14}/></button>
                    <button className="aaCatAction cancel" onClick={() => setEditingId(null)}><FiX size={14}/></button>
                  </>
                ) : (
                  <>
                    <div className="aaCatName">{c.name}</div>
                    <div className="aaCatActions">
                      <button className="aaCatAction" onClick={() => startEdit(c)}><FiEdit2 size={14}/></button>
                      <button className="aaCatAction danger" onClick={() => handleDelete(c.id, c.name)}><FiTrash2 size={14}/></button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}